module.exports = __webpack_public_path__ + "static/media/background-img-bottom.a8e039d5.svg";